import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import { PARTY_ROLE_LOOKUP_ITEMS } from "components/form/forms/voucher/TransactionPartiesField";
import { DealExtended } from "types/api/deal/dealExtended";
import { TransactionDetailRead } from "types/api/deal/transaction_detail";

const TransactionPartiesDetail = ({
  record,
  fieldName,
  label,
}: {
  record: DealExtended;
  fieldName: string;
  label: string;
}) => {
  if (
    !Array.isArray(record.transaction_parties) ||
    record.transaction_parties.length === 0
  )
    return "No contacts have been added";

  return (
    <TableContainer
      sx={{ border: 1, borderColor: "divider", borderTop: 0, borderRadius: 2 }}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Role</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Address</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(record.transaction_parties as TransactionDetailRead[]).map(
            (party, index) => {
              const roleLabel =
                PARTY_ROLE_LOOKUP_ITEMS.find(
                  (r) => r.key === (party as any).role
                )?.label || (party as any).role;
              const companyName = (party as any)?.company?.label || "";
              const contactName = [
                (party as any)?.first_name,
                (party as any)?.last_name,
              ]
                .filter(Boolean)
                .join(" ");
              const nameDisplay = [companyName, contactName]
                .filter(Boolean)
                .join(" - ");

              const addressDisplay = [
                (party as any).address_line_1,
                (party as any).address_line_2,
                (party as any).address_city,
                (party as any).address_state,
                (party as any).address_postal_code,
              ]
                .filter(Boolean)
                .join(", ");

              return (
                <TableRow key={party.id ?? index}>
                  <TableCell>{roleLabel}</TableCell>
                  <TableCell>{nameDisplay || "—"}</TableCell>
                  <TableCell>{addressDisplay || "—"}</TableCell>
                </TableRow>
              );
            }
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TransactionPartiesDetail;
